// extracted by mini-css-extract-plugin
module.exports = {"itemLink":"index_itemLink_BX6QU","itemAction":"index_itemAction_DVTh6","itemMeta":"index_itemMeta_2k94I","item":"index_item_AUmiz"};